import { get, post, put, Delete } from "../axios";

// 课程包-列表
export const coursePackageList = (params) =>
  get("/web/course/package/list", params);

// 课程包-新增
export const coursePackageAdd = (params) =>
  post("/web/course/package/add", params);

// 课程包-删除
export const coursePackageDelete = (id) =>
  Delete("/web/course/package/delete/" + id, "");

// 课程包-编辑
export const coursePackageUpdate = (params) =>
  put("/web/course/package/update", params);

// 课程包-状态编辑
export const coursePackageStateUpdate = (params) =>
  put("/web/course/package/state/update", params);

// 课程包-推荐首页编辑
export const coursePackageHomeUpdate = (params) =>
  put("/web/course/package/home/update", params);

// 课程包-全部数据
export const coursePackageListAll = () =>
  get("/web/course/package/listAll");

// 课程包-详情
export const coursePackageDetail = (id) =>
  get("/web/course/package/view/" + id);

